import React from "react";
import { styled } from "@mui/material/styles";

interface Props {
  children: React.ReactNode;
}

export const PaneListEmptyPlaceholder = (props: Props) => {
  return <Styles>{props.children}</Styles>;
};

const Styles = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 75px;
  width: 100%;
  padding: 0 17px;

  border-radius: 4px;
  border: 2px solid #e9e9e9;
  background-color: transparent;

  font-style: italic;
  color: #00000070;
`;
